import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { StateCultureEditService } from '../../service/stateculture-edit/stateculture-edit.service';
import { StateListService } from '../../../state/service/state-list/state-list.service';
import { CultureListService } from '../../../culture/service/culture-list/culture-list.service';

@Component({
	selector: 'app-stateculture-edit',
	templateUrl: './stateculture-edit.component.html',
	providers: [
		StateCultureEditService,
		StateListService,
		CultureListService,
		HttpModule
	]
})

export class StateCultureEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	public states: any[] = [];
	public cultures: any[] = [];
	stateCulture: FormGroup;
	statusCulture: boolean;
	public nomeEstado: string;
	public descricaoCultura: string;
	public unidadeMedidaCultura: string;
	private estadoID: string;
	private culturaID: string;
	private ID: string;

	constructor(fb: FormBuilder, private stateCultureEditService: StateCultureEditService, private stateListService: StateListService, private cultureListService: CultureListService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.stateCulture = fb.group({
			'ID':'',
			'CulturaID': '',
			'EstadoID':'',
			'ProdutividadeMedia': [null, Validators.compose([Validators.required])],
			'Preco': [null, Validators.compose([Validators.required])],
			'PorcentagemFertilizanteCusto': [null, Validators.compose([Validators.required])],
			'MediaFertilizante': [null, Validators.compose([Validators.required])],
			'Custo': [null, Validators.compose([Validators.required])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.stateCultureEditService.loadStateCulture(this.token, this.ID).subscribe(result => {
				var updateCulture = result.Result;
				this.stateCulture.setValue({
					ID: updateCulture.ID,
					CulturaID: updateCulture.CulturaID,
					EstadoID: updateCulture.EstadoID,
					ProdutividadeMedia: updateCulture.ProdutividadeMedia,
					Preco: updateCulture.Preco,
					PorcentagemFertilizanteCusto: updateCulture.PorcentagemFertilizanteCusto,
					MediaFertilizante: updateCulture.MediaFertilizante,
					Custo: updateCulture.Custo,
					Ativo: updateCulture.Ativo
				});
				this.nomeEstado = updateCulture.Estado.Nome;
				this.descricaoCultura = updateCulture.Cultura.Descricao;
				this.unidadeMedidaCultura = updateCulture.Cultura.UnidadeMedida;
			})
		}, error => {
			console.log(error);
		});
	}




	updateStateCulture(value: any) {
		console.log(value);
		this.stateCultureEditService.updateStateCulture(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Cultura por Estado editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/culturaestado');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/culturaestado');
	}

}



// WEBPACK FOOTER //
// ./src/app/stateculture/component/stateculture-edit/stateculture-edit.component.ts